module.exports = __webpack_public_path__ + "media/arrows/arrow--blue-db0386bd.svg";